import React from 'react';
import PropTypes from 'prop-types';
import Card from './Card';
import { DealModal } from './DealModal';

const CardColumns = ({ list }) => {
  const cardColumns = list.map((deal, index) => {
    return (
      <Card key={deal._id || `deal_${index}`} {...deal} />
    );
  });
  return cardColumns;
};

CardColumns.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export class CardGrid extends React.Component {
  render() {
    return (
      <div>
        <DealModal modal={this.props.modal} />
        <div className="container">
          <div className="deal-grid">
            <CardColumns list={this.props.list} />
          </div>
        </div>
      </div>
    );
  }
}

CardGrid.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  modal: PropTypes.object,
};
